import { Download } from "@mui/icons-material";
import { Button } from "@mui/material";

const DownloadButton = ({ onClick, disabled = false }) => {
  return (
    <Button
      variant="contained"
      startIcon={<Download />}
      onClick={onClick}
      disabled={disabled}
      sx={{ textTransform: "none" }}
    >
      Download
    </Button>
  );
};

export default DownloadButton;
